import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormControl } from '@angular/forms';
import { ExitProcessService } from 'src/app/_services/exit-process/exit-prosess.service';
import { UserService } from 'src/app/_services/user/user.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-emply-anknowledge',
  templateUrl: './emply-anknowledge.component.html',
  styleUrls: ['./emply-anknowledge.component.scss']
})
export class EmplyAnknowledgeComponent implements OnInit {
  @Output() clearanceEvent = new EventEmitter<any>();
  tenantId: string;
  currentUser: any;
  isHRAdmin: boolean;
  isFinanceAdmin: boolean;
  isITAdmin: boolean;
  resignationId: any;
  clearanceUserId: any;
  isManager: boolean = false;
  isVisible: boolean;
  isEmployeeFormVisible: boolean;
  userClearanceData: any[] = [];
  userClearance= [];
  empAckForm
  exitStatus: any;
  employeeName: any;
  modeAction: number = 1; //1 - create // 2 - update
  date: Date;
  TodayDate: string;
  clearanceId: any;
  isDateDisabled: boolean;
  dateOfAck: any;
  isUser: boolean;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
    private route : ActivatedRoute,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private exitProcessService: ExitProcessService,
    private userService: UserService,
    private datePipe: DatePipe,
  ) { 
      this.route.queryParams.subscribe(params => {
        this.resignationId = params['resignationId'];
      });

      this.empAckForm = this.formBuilder.group({
        itemName: new FormControl({value: '', disabled: true}),
        status: new FormControl({value: '', disabled: true}),
        extraColumn1: new FormControl({value: ''}),
      });
  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isHRAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
    this.isFinanceAdmin = this.currentUser.roles.includes('RoleFinanceAdministrator') ;
    this.isITAdmin = this.currentUser.roles.includes('RoleITAdministrator') ;
    this.date = new Date();
    let latest_date = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.TodayDate = latest_date;
    // if(this.isHRAdmin){
    //   this.isVisible = true;
    // }
    // else{
    //   this.isVisible = false;
    // }
    this.getUserSeparation(this.resignationId);
  }

  getUserSeparation(resignationId){
    this.exitProcessService.getUserSeparationsById(resignationId).subscribe({
      next : (value) => {
        this.clearanceUserId = value['userId'];
        this.exitStatus = value['status'];
        this.getUserById(value['userId']);
        this.getUserClearanceData();
        this.employeeName = value['userName']
        if(this.currentUser.id === this.clearanceUserId){
          this.isUser = true;
        }
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Resignation Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  getUserClearanceData(){
    this.exitProcessService.getUserClearanceForm('Misc', this.resignationId).subscribe({
      next : (value: any) => {
        this.userClearanceData = [];
        this.userClearanceData = value;
        const acknowledgment = this.userClearanceData.find(data => data.itemName === 'Acknowledgment by Employee');
        this.isDateDisabled = acknowledgment ? acknowledgment.status === "Done" : null;
        this.clearanceId = acknowledgment ? acknowledgment.id : null;
        this.dateOfAck = acknowledgment ? acknowledgment.extraColumn1 : null;
        
        if(this.dateOfAck){
          this.empAckForm.value.extraColumn1 = this.dateOfAck;
          this.empAckForm.patchValue(this.empAckForm.value)
        }else{
          this.empAckForm.value.extraColumn1 = this.TodayDate;
          this.empAckForm.patchValue(this.empAckForm.value);
        }

        this.clearanceEvent.emit(value);
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Clearance Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  getUserById(selectedUserId) {
    this.userService.getUser(selectedUserId).subscribe({
      next: (response) => {
        if(this.currentUser.id === response['supervisorId']){
          this.isManager = true;
        }
      },
      error: () => {

      },
      complete: () => {

      }
    })
  }

  editOpenModal() {
    this.modeAction = 1;
  }

  confirmation(){
    if(this.isDateDisabled === true){
      this.openSnackBar('Acknowledgement is already done!!!');
      $('#closeModalconfirmAck').trigger('click');
    }
    else{
      let data = {
        userId: this.clearanceUserId,
        itemName: 'Acknowledgment by Employee',
        status: 'Done',
        extraColumn1: this.empAckForm.get('extraColumn1').value,
        clearanceType: 'Misc',
      }
      this.exitProcessService.editClearanceInterviewForm(data, this.clearanceId).subscribe(() => {
        this.openSnackBar('Acknowledgement Successful!!!');
        $('#closeModalconfirmAck').trigger('click');
      });
    }
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  backToExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-process']);
  }

  openFinanceExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-finance' ], { queryParams: { resignationId: this.resignationId } });
  }

  openItHrmExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hrit' ], { queryParams: { resignationId: this.resignationId } });
  }

  ExitEmployeeForm(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-employee-form'], {queryParams: {userId: this.currentUser.id}});
  }

  openDepartmentExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-department'], {queryParams: {resignationId: this.resignationId}});
  }

  openHrExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hr-admin'], {queryParams: {resignationId: this.resignationId}});
  }

  openExitForm(){
    this.router.navigate([this.tenantId + '/dashboard/hr/exit-formalities/exit-form'], { queryParams: { resignationId: this.resignationId } });
  }
}
